import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UInputComponent } from '@local/ui-infra';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { QuestionnaireService } from 'src/app/bar/services/questionnaire.service';
import { ExperienceSearchItem } from 'src/app/bar/views/results';
import { isTitleEditableAssistant } from '@local/common-web';

@UntilDestroy()
@Component({
  selector: 'questionnaire-section',
  templateUrl: './questionnaire-section.component.html',
  styleUrls: ['./questionnaire-section.component.scss'],
})
export class QuestionnaireSectionComponent {
  private _assistant: ExperienceSearchItem;
  formInputChanged = new Subject<string>();
  isNewMode: boolean;

  @Output() changeTitle = new EventEmitter<string>();
  @Input() title: string;
  @Input() set assistant(val: ExperienceSearchItem) {
    this._assistant = val;

    let newMode = (<any>this.location.getState()).mode;
    if (Array.isArray(newMode)) newMode = newMode[0];
    this.isNewMode = !!newMode;

    this.cdr.markForCheck();
  }
  @Input() disabledButton: boolean;

  get assistant(): ExperienceSearchItem {
    return this._assistant;
  }

  @ViewChild('inputTitle') inputTitle: UInputComponent;

  constructor(
    private cdr: ChangeDetectorRef,
    private location: Location,
    private questionnaireService: QuestionnaireService
  ) {}

  ngAfterViewInit(): void {
    this.formInputChanged.pipe(debounceTime(800), distinctUntilChanged(), untilDestroyed(this)).subscribe((value) => {
      if (!isTitleEditableAssistant(this.assistant)) {
        return;
      }
      if (this.assistant?.settings?.title === value || !value) {
        return;
      }
      this.changeTitle.emit(value);
      this.cdr.markForCheck();
    });

    if (this.isNewMode) {
      setTimeout(() => {
        this.inputTitle?.focusInput();
      }, 0);
    }
  }

  fillRfp() {
    if (this.disabledButton) {
      return;
    }
    this.questionnaireService.open({ assistantId: this.assistant.id });
  }
}
